module.exports = __webpack_public_path__ + "static/media/wasmer-logo.dcd2c36e.png";